




export default {
  props: {
    /**
     * The length and width of the tiles in pixels
     */
    size: Number,
  },
};
